import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/lib/auth-context";

const RANGES = [["7d", "7 days"], ["30d", "30 days"], ["all", "All time"]];

export default function BookingEnquiriesSection() {
  const { hasPerm } = useAuth();
  const allowed = hasPerm("view_reports");
  const [range, setRange] = useState("30d");
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!allowed) return;
    api.get(`/reports/booking-enquiries?range=${range}`).then(({ data }) => setData(data)).catch((e) => toast.error(formatError(e)));
  }, [range, allowed]);
  if (!allowed || !data) return null;
  return (
    <div className="w-card w-card-bordered p-5" data-testid="booking-enquiries-section">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="label-caps gold">Book a Trip enquiries (WhatsApp)</div>
        <div className="inline-flex rounded-full p-0.5" style={{ background: "var(--bg-soft)" }}>
          {RANGES.map(([k, l]) => (
            <button key={k} type="button" onClick={() => setRange(k)} data-testid={`booking-enq-range-${k}`}
                    className={`px-3 h-7 rounded-full text-xs font-medium ${range === k ? "bg-navy text-white" : ""}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="mt-3 text-sm">Total enquiries sent: <b data-testid="booking-enq-total">{data.total_enquiries}</b></div>
      <table className="w-full text-sm mt-3">
        <thead><tr style={{ color: "var(--text-muted)" }}><th className="text-left py-2 label-caps">Service</th><th className="text-right py-2 label-caps">Enquiries</th></tr></thead>
        <tbody>
          {data.services.map((s) => (
            <tr key={s.service_id} style={{ borderTop: "1px solid var(--border)" }}>
              <td className="py-2">{s.name}</td>
              <td className="py-2 text-right font-semibold" data-testid={`booking-enq-count-${s.service_id}`}>{s.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
